export const protocolSummaryColumns = (t) => [
  { field: "regionalName", header: t("PROTOCOL_SUMMARY.COLUMNS.REGIONAL") },
  { field: "clientName", header: t("PROTOCOL_SUMMARY.COLUMNS.CLIENT") },
  { field: "email", header: t("PROTOCOL_SUMMARY.COLUMNS.EMAIL") },
  { field: "quantity", header: t("PROTOCOL_SUMMARY.COLUMNS.QUANTITY") },
  { field: "oldestProtocolDate", header: t("PROTOCOL_SUMMARY.COLUMNS.OLDEST_PROTOCOL_DATE") },
  { field: "administrativeRestriction", header: t("PROTOCOL_SUMMARY.COLUMNS.ADMINISTRATIVE_RESTRICTION") },
];
